import { useNavigate } from "react-router-dom";
import { Home } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ThemeToggle } from "@/components/theme-toggle";

interface RulebookPageProps {
  title: string;
  children: React.ReactNode;
}

export function RulebookPage({ title, children }: RulebookPageProps) {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen p-4">
      <ThemeToggle />
      <div className="max-w-3xl mx-auto">
        <div className="flex items-center justify-center mb-6 relative">
          <Button
            variant="outline"
            size="sm"
            onClick={() => navigate("/")}
            className="flex items-center gap-2"
          >
            <Home className="h-4 w-4" />
            Home
          </Button>
        </div>
        <h1 className="text-3xl font-bold mb-6 text-center">{title}</h1>
        {children}
      </div>
    </div>
  );
}
